import { ContentHeader } from '@features/core/ui/layout/contentHeader';

import { Header } from '../header';

export const AdminHeader = () => {
  return (
    <Header className={'mt-5 items-center'}>
      <ContentHeader />
    </Header>
  );
};
